import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
import 'core-js/es/map'
import 'core-js/es/set'
import 'raf/polyfill'
import 'react-app-polyfill/ie11'

import './style/index.scss'
import { App } from '@src/App'
import reportWebVitals from './reportWebVitals'
import { store } from './store/store'

// window.close()

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn: 'https://c222f09600c3481b90d39ed00f1b5dff@o359059.ingest.sentry.io/6132859',
    integrations: [new Integrations.BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  })
}

ReactDOM.render(
/*  <React.StrictMode> */
  <BrowserRouter>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>, /* </React.StrictMode> */
  document.getElementById('root'),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
